import { DragTypeEnum } from "../enums";
import { TNoDrag, TNotDragging } from "../models";

export const NAVBAR_DROPPABLE_AREA_ID = "navbar_item_droppable";

export const NotDraggingDataConst: TNoDrag = {
  type: DragTypeEnum.NOT_DRAGGING,
  payload: false,
};

export const NotDraggingConst: TNotDragging = { dragging: false };
